<template>
	<div class="app-wrapper">
		<cheader></cheader>
		<div class="main-wrapper">
			<navBar></navBar>
			<div class="main" ref="main" id="main">
				<breadcrumb />
				<appMain></appMain>
			</div>
		</div>
	</div>
</template>
<script>
import cheader from './components/cheader'
import navBar from './components/navBar'
import appMain from './components/appMain'
import breadcrumb from './components/breadcrumb'
export default {
	components: {
		cheader,
		navBar,
		appMain,
		breadcrumb
	}
}
</script>
<style lang="scss" scoped>
@import 'src/styles/mixin.scss';
.app-wrapper {
	@include clearfix;
	height: 100%;
	background-color: #f1f5fb;
	min-width: 1200px;
	.main-wrapper {
		height: 100%;
		padding-top: 72px;
		overflow: hidden;
		.main {
			height: 100%;
			overflow: auto;
			padding: 0 40px 18px;
		}
	}
}
</style>
